/* eslint-disable */
export default {
  activeCall: '활성 통화',
} as const;

// @key: @#@"activeCall"@#@ @source: @#@"Active Call"@#@
